"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEASURE_SCORING_KEYS = exports.MeasureScoring = void 0;
var MeasureScoring;
(function (MeasureScoring) {
    MeasureScoring["COHORT"] = "Cohort";
    MeasureScoring["CONTINUOUS_VARIABLE"] = "Continuous Variable";
    MeasureScoring["PROPORTION"] = "Proportion";
    MeasureScoring["RATIO"] = "Ratio";
})(MeasureScoring = exports.MeasureScoring || (exports.MeasureScoring = {}));
exports.MEASURE_SCORING_KEYS = new Map(Object.entries(MeasureScoring).map(([k, v]) => [v, k]));
